import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Root = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  display: "flex",
  flexDirection: "column",
  height: "100%",
  overflow: "hidden",
  boxSizing: "border-box",
}));

export const StyledSettingsWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  marginTop: theme.spacing(1),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1),
  width: "100%",
  flex: "0 0 auto",
  backgroundColor: theme.palette.background.paper,
}));

export const StyledDisplayView = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexWrap: "wrap",
  marginTop: theme.spacing(1),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1),
  width: "100%",
  flex: "1 1 auto",
  minHeight: 0,
  overflowY: "auto",
  boxSizing: "border-box",
  height: "auto",
}));

export const StyledSettings = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: theme.spacing(1),
  width: "100%",
  height: 88,
}));

export const StyledSettingsColumn = styled(Box)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  minWidth: 300,
  width: "100%",
});

export const StyledSettingsButtons = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});
